// Kill switch for the Sound Map (route, nav item, prefetch, tour chapter).
export const MAP_ENABLED = true
